import { SubscriptionIntegrationSchema } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import * as z from "zod/v4";

export const skipSubscription = {
  name: "skipSubscription" as const,
  input: z.object({ subscriptionId: z.number() }),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    subscription: SubscriptionIntegrationSchema.optional(),
  }),
};
